import React from 'react';
import { useTranslation } from 'react-i18next';
import { RadioLabel, Section, Date } from '@weezevent/nacre';
import i18n from '../../i18n/i18n';
import './exportPeriod.scss';

export default function ExportPeriod({ onStartDate, onEndDate, section = true }) {
    const { t } = useTranslation();
    const locale = i18n.language;
    const [data, setData] = React.useState(null);

    const onChangeDate = React.useCallback(
        (from_date, to_date) => {
            setData({ from_date: from_date, to_date: to_date });
            onStartDate(from_date);
            onEndDate(to_date);
        },
        [onStartDate, onEndDate]
    );

    return (
        <div className="export-period-container">
            <div className="content">
                <div className="radio-label-content">
                    <div className={`radio-button ${data === null ? 'radio-button-active' : ''}`}>
                        <RadioLabel
                            label={t('ticket.services.radio-label-full-report')}
                            name="all_dates"
                            checked={data === null}
                            active={data === null}
                            onClick={() => {
                                setData(null);
                                onStartDate(null);
                                onEndDate(null);
                            }}
                        />
                    </div>
                    <div className={`radio-button ${data !== null ? 'radio-button-active' : ''}`}>
                        <RadioLabel
                            label={t('ticket.services.radio-label-partial-report')}
                            name="selected_dates"
                            checked={data !== null}
                            active={data !== null}
                            onClick={() => setData({ from_date: null, to_date: null })}
                        />
                    </div>
                </div>
                {data !== null && (
                    <div>
                        {section ? (
                            <Section>
                                <div>{t('ticket.services.dates')}</div>
                                <Date.Range locale={locale} onChange={onChangeDate} maxYear={2050} returnFormat={'YYYY-MM-DD'} />
                            </Section>
                        ) : (
                            <>
                                <div>{t('ticket.services.dates')}</div>
                                <Date.Range locale={locale} onChange={onChangeDate} maxYear={2050} returnFormat={'YYYY-MM-DD'} />
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
